import { Button } from "@sellar-io/components";
import { Alert } from "../../../components/alert/Alert";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../components/modal/Dialog";
import { apiV2AssertError } from "../../../hooks/api/v2/apiV2Request";
import { useProductDelete } from "../../../hooks/api/v2/product/useProductDelete";

export const ProductDeleteDialog = ({
  productName,
  productId,
  onDismiss,
  active,
  onDelete,
}: {
  productName: string;
  productId?: number | undefined;
  onDismiss: () => void;
  active: boolean;
  onDelete?: () => void;
}) => {
  const productDeleteMutation = useProductDelete(productId ?? 0);

  return (
    <Dialog active={active} onDismiss={onDismiss} className="m-4 h-fit">
      {productDeleteMutation.isError && (
        <Alert
          type={"error"}
          message={
            apiV2AssertError(productDeleteMutation.error)?.response?.data
              .message ?? "Unknown error"
          }
        />
      )}

      <DialogNavigation
        title={`Remove ${productName}`}
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
      />

      <DialogContent className="flex justify-center text-zinc-500">
        Are you sure you wish to delete this item?
      </DialogContent>

      <DialogCTA>
        <Button
          color={"red"}
          onClick={() =>
            productDeleteMutation.mutate(undefined, {
              onSuccess: () => {
                onDismiss();
                onDelete?.();
              },
            })
          }
          disabled={!productId || productDeleteMutation.isPending}
        >
          Delete
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
